<template>
  <div class="wrapperswc">
    <div class="datecalendarbtn">
      <p>{{ month }} {{ year }}</p>
      <img @click="$emit('calendarView')"
          src="/src/assets/images/calendario_icon.svg"
          class="navigationItem">
    </div>
    <div style="position:relative;">
      <div @click="scrollPreviousWeek" class="btn left">
        <i class="fa fa-chevron-left"></i>
      </div>
      <div @click="scrollNextWeek" class="btn">
        <i class="fa fa-chevron-right"></i>
      </div>
      <div class="calendar" ref="calendar">
        <div v-for="(week,index) in weeks"
          :winx="index"
          draggable="true"
          @dragstart="handleDragStart(index, $event)"
          @dragover.prevent="handleDragOver(index, $event)"
          class="week">
          <div class="day"
            v-for="dia in week"
            @click="$emit('showday', dia)">
            <span class="letter">{{ dia.label }}</span>
            <span class="number" :class="{ 'active': dia.value == activeday }">
              {{ dia.number }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const formatterdayname =
  new Intl.DateTimeFormat("pt-PT", {
    weekday: "short"
  });

const formatter =
  new Intl.DateTimeFormat("pt-PT", {
    day: "2-digit"
  });

const formatterMonth =
  new Intl.DateTimeFormat("pt-PT", {
    month: "long",
  });

const formatterYear =
  new Intl.DateTimeFormat("pt-PT", {
    year: "numeric",
  });

export default {
  name: 'SmallWeekCalendar',
  props: ["selectedWeek", "activeday"],
  emits: ["showday", "calendarView"],
  data() {
    return {
      days: [],
      weeks: [],
      month: "",
      year: 0,
      weeksize: 0,
      observer: null,
      currentStartWeekDate: null
    }
  },
  computed: {
    visibleWeeks() {
      return this.weeks;
    }
  },
  created() {
    this.month = formatterMonth.format(this.selectedWeek.start);
    this.year = formatterYear.format(this.selectedWeek.start);
    this.currentStartWeekDate = this.selectedWeek.start;
    this.days = this.generateDaysForHeader();
    this.generateWeeksForHeader();
    this.maxWeekIndex = this.weeks.length - 1;
  },
  mounted(){
    this.setScrollPositionOnMiddle();
  },
  methods: {
    observeWeeks(){
      const weeks = document.querySelectorAll(".weeks");
      const options = this.getObserverOptions();
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          let index = entry.target.getAttribute("winx");
          if (entry.isIntersecting) {
            console.log("entry.isIntersecting");
            if (index == 0) {
              this.addPrevious3Weeks();
            }else if (index == this.weeks.length - 1) {
              this.addNext3Weeks();
            }
          }
        });
        this.$nextTick(() => {
          const newHeaders = document.querySelectorAll(".weeks");
          newHeaders.forEach((week) => this.observer.observe(week));
        });
      },options);
      weeks.forEach((week) => this.observer.observe(week));
    },
    getObserverOptions() {
      const percentageOfElementVisibleOnScreen = 0.2;
      return {
        root: this.$refs.eventListContainer,
        rootMargin: "0px",
        threshold: percentageOfElementVisibleOnScreen,
      };
    },
    getWeekForDate(startDate) {
      startDate.setDate(startDate.getDate() - 7);
      return {
        label: formatterdayname.format(startDate).charAt(0).toUpperCase(),
        number: formatter.format(startDate),
        value: this.getNumberWeekDay(i),
      }
    },
    addPrevious3Weeks() {
      console.log("addPrevious3Weeks");
      const oneWeekAgo = new Date(this.currentStartWeekDate);
      const weeks = [];
      for (let i = 1; i <= 3; i++) {
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7); 
        const newWeek = this.getWeekForDate(oneWeekAgo); 
        weeks.unshift(newWeek)
      }
      this.weeks = [...weeks,...this.weeks];
    },
    addNext3Weeks() {
      console.log("addNext3Weeks");
      const oneWeekAgo = new Date(this.currentStartWeekDate);
      const weeks = [];
      for (let i = 1; i <= 3; i++) {
        oneWeekAgo.setDate(oneWeekAgo.getDate() + 7); 
        const newWeek = this.getWeekForDate(oneWeekAgo); 
        weeks.push(newWeek)
      }
      this.weeks = [...this.weeks, ...weeks];
    },
    setScrollPositionOnMiddle(){
      const week = document.querySelector(".week");
      this.weeksize = week.clientWidth;
      this.$refs.calendar.scrollLeft = week.clientWidth * Math.floor(this.weeks.length/2)
    },
    handleDragStart(index, event) {
      console.log("handleDragStart");
    },
    handleDragOver(index,event){
      console.log("handleDragOver");
      event.preventDefault();
    },
    handleDrop(index,event){
      console.log("handleDrop");
    },
    scrollNextWeek(){
      this.$refs.calendar.scrollLeft += this.weeksize;
      this.currentStartWeekDate = this.currentStartWeekDate.setDate(this.currentStartWeekDate.getDate() + 7);
    },
    scrollPreviousWeek(){
      this.$refs.calendar.scrollLeft -= this.weeksize;
      this.currentStartWeekDate = this.currentStartWeekDate.setDate(this.currentStartWeekDate.getDate() - 7);
    },
    generateWeeksForHeader() {
      let startDate = new Date(this.selectedWeek.start);
      startDate.setDate(startDate.getDate() - 7);
      for (let index = 0; index < 3; index++) {
        let week = [];
        for (var i = 0; i < 7; i++) {
          week.push({
            label: formatterdayname.format(startDate).charAt(0).toUpperCase(),
            number: formatter.format(startDate),
            value: this.getNumberWeekDay(i),
          });
          startDate.setDate(startDate.getDate() + 1);
        }
        this.weeks.push(week);
      }
    },
    generateDaysForHeader() {
      let startDate = new Date(this.selectedWeek.start.getTime());
      let days = [];
      for (var i = 0; i < 7; i++) {
        days.push({
          label: formatterdayname.format(startDate).charAt(0).toUpperCase(),
          number: formatter.format(startDate),
          value: this.getNumberWeekDay(i),
        });
        startDate.setDate(startDate.getDate() + 1);
      }
      return days;
    },
    getNumberWeekDay(number) {
      if (number < 6) {
        return number + 2;
      }
      return 1
    }
  }
}
</script>

<style scoped>

.btn{
  display: none;
}

@media (hover: hover) {
  .btn{
    display: block;
    position: absolute;
    right: -10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }

  .btn.left{
    left: -10px;
  }
}

.wrapperswc {
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 40px;
  padding-bottom: 20px;
  background: #f3f4f6;
}

.datecalendarbtn {
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: space-between;
  margin-bottom: 10px;
}

p {
  font-family: "Montserrat";
  color: black;
  margin-bottom: 0;
  text-transform: capitalize;
}

.navigationItem {
  width: 20px;
}

.day {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  flex-grow: 1;
  /* each day will take up an equal amount of space */
  padding-right: 10px;
  padding-left: 10px;
}

.day .letter {
  font-size: 10px;
  color: #a8aaab;
}

.day .number {
  font-size: 20px;
  font-family: "Montserrat SemiBold";
  padding-left: 5px;
  padding-right: 5px;
}

.day .number.active {
  background: #2e59e4;
  color: white;
  border-radius: 50%;
}


.calendar {
  display: flex;
  flex-direction: row;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  /* optional: enables smoother scrolling on iOS */
  scroll-snap-type: x mandatory;
  /* enable snapping */
  scroll-behavior: smooth;
  /* enable smooth scrolling */
  width: 100%;
  position: relative;
}

.calendar::-webkit-scrollbar {
  width: 0rem;
  height: 0rem;
  background-color: transparent;
}

.week {
  display: flex;
  flex-direction: row;
  flex: 0 0 100%;
  /* take up the full width of the container */
  scroll-snap-align: start;
  /* snap to the left edge of the container */
  user-select: none;
}
</style>